import httpRequest from "utils/httpRequest";
const URL = "/api";

export const getChangesLog = async (group_id,start_date,end_date) => {  
  const requestBody = {
    group_id,
    start_date,
    end_date,
  };
  try {
    const response = await httpRequest("post", `${URL}/getChangesLog`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};